<script>
import GlobalVue from '@helper/Global.vue';
import Gen from '@helper/Gen';
// import swal from 'sweetalert';

export default {
  extends:GlobalVue,
  mounted(){
    this.refreshMeta()
  },
  methods:{
    refreshMeta(){
      Gen.rest(this.$route.path, {metainfo:true},(err,resp)=>{
        if(err) return console.error(err)
        $("title").text(resp.meta_title)
        $("meta[property='og:image']").attr('content', resp.ss_img)
        $("meta[property='og:title']").attr('content', resp.meta_title)
        $("meta[name='description']").attr('content', resp.ss_meta_desc)
        $("meta[property='og:description']").attr('content', resp.ss_meta_desc)
        $("meta[name='keywords']").attr('content', resp.ss_meta_keyword)
        $("meta[name='author']").attr('content', resp.ss_author)
        $("meta[property='og:site_name']").attr('content', resp.ss_sitename)
        $("meta[property='url']").attr('content', resp.ss_url)
        $("link[rel='canonical']").attr('content', resp.ss_url)
        this.$root.meta = resp
      })
    },
    addFavorite(v){
      if(this.user){
        Gen.apirest("/post-favorite",{data:v.apd_id,id:this.user.u_id},(err,resp)=>{
            if(err) console.log(err)
              if(resp.status === 'Y'){
                  $('#fav_'+v.apd_id).find('i').removeClass('icon-line-heart');
                  $('#fav_'+v.apd_id).find('i').addClass('icon-heart3');
              } else {
                  $('#fav_'+v.apd_id).find('i').removeClass('icon-heart3');
                  $('#fav_'+v.apd_id).find('i').addClass('icon-line-heart');
              }
        })
      } else {
        this.$router.push({name:'Login'})
      }
    }
  },
  watch:{
    $route(){
      this.refreshMeta()
    }
  }
}

</script>
